import type { ServerMetadata } from "@app/lib/actions/mcp_internal_actions/tool_definition";
import { MorningBriefingTaskProposalSchema } from "@app/lib/api/morning_briefing/proposal_schema";
import { z } from "zod";

export const MORNING_BRIEFING_SERVER_NAME = "morning_briefing" as const;
export const GET_CONTEXT_TOOL_NAME = "get_context" as const;
export const PROPOSE_TASKS_TOOL_NAME = "propose_tasks" as const;

export const MORNING_BRIEFING_TOOLS_METADATA = [
  {
    name: GET_CONTEXT_TOOL_NAME,
    description:
      "Get the Morning Briefing reporting window and normalized MemoAir tasks, pending approvals, and recent conversations.",
    schema: {},
    stake: "never_ask",
    eager: true,
    displayLabels: {
      running: "Gathering briefing context",
      done: "Gathered briefing context",
    },
    toolCostCategory: "basic",
    freeUsage: true,
  },
  {
    name: PROPOSE_TASKS_TOOL_NAME,
    description:
      "Propose only high-confidence unfinished actions from this Morning Briefing as pending personal tasks for review.",
    schema: {
      proposals: z.array(MorningBriefingTaskProposalSchema),
    },
    // Pending personal tasks are themselves the review step; a modal on an
    // unattended routine run would make this the one path the briefing cannot
    // take.
    stake: "never_ask",
    eager: true,
    displayLabels: {
      running: "Proposing briefing tasks",
      done: "Proposed briefing tasks",
    },
    toolCostCategory: "basic",
    freeUsage: true,
  },
] as const;

export const MORNING_BRIEFING_SERVER = {
  serverInfo: {
    name: MORNING_BRIEFING_SERVER_NAME,
    version: "1.0.0",
    description:
      "Gather grounded Morning Briefing context and propose pending personal tasks from this run.",
    authorization: null,
    icon: "ActionCheckCircleIcon",
    documentationUrl: null,
  },
  tools: MORNING_BRIEFING_TOOLS_METADATA,
} as const satisfies ServerMetadata;
